import React, { useMemo } from 'react'
import { reasonCodeAndDescriptionRowData } from '../service/reasonCodeDescriptionRowData'

export const ReasonCodeAndDescription = () => {
    const tableData = useMemo(() => reasonCodeAndDescriptionRowData().map(item => {
        return (
            <tr id={item.id}>
                <td>{item.Description}</td>
                <td>{item.Code}</td>
            </tr>
        )
    }))

    return (
        <table>
            <tr>
                <tr>
                    <th>Description</th>
                    <th>Code</th>
                </tr>
                {tableData}
            </tr>
        </table>
    )
}
